import React from "react";

import { FormControl, TextField } from "@mui/material";

import { googleEnhanceAuth } from "helpers/destinations/createDestination";

import GoogleOfflinePixels from "components/GoogleOfflinePixels";
import LoginButton from "components/molecules/LoginButton";

const getAuthUrlResponseTransform = (response) => response?.data?.url;

const toGoogleCode = (params) => ({ google_code: params.code });

/** Google Offline / Web Conversions: name, Google login, account + mapping. */
const GoogleEnhancedForm = ({
    language,
    destinationCode,
    googleEnhanced,
    setSaveDisabled,
}) => {
    const nameLabel = language?.destination_modal?.name ?? "Name";

    return (
        <div>
            <FormControl className="mb-3" style={{ width: "100%" }}>
                <TextField
                    name="name"
                    label={nameLabel}
                    variant="outlined"
                    onChange={googleEnhanced.handleNameChange}
                    value={googleEnhanced.name}
                    placeholder={nameLabel}
                />
            </FormControl>

            {!googleEnhanced.isConnected && (
                <div className="position-relative overflow-hidden z-1">
                    <LoginButton
                        code="google"
                        getAuthUrl={googleEnhanceAuth}
                        getAuthUrlData={{ type_name: "google_adwords" }}
                        getAuthUrlResponseTransform={
                            getAuthUrlResponseTransform
                        }
                        paramNames={["code"]}
                        onSuccess={googleEnhanced.handleLoginSuccess}
                        dataTransform={toGoogleCode}
                        logoSrc="/assets/images/google.png"
                        buttonText={
                            language?.buttons?.connect_with_google ??
                            "Connect with Google"
                        }
                        disabled={!googleEnhanced.name?.length}
                        isLoadingExternal={googleEnhanced.isAuthLoading}
                    />
                </div>
            )}
            {googleEnhanced.isConnected && (
                <GoogleOfflinePixels
                    setButtonDisabledStatus={setSaveDisabled}
                    setEnhanceMapping={googleEnhanced.setMapping}
                    setEnhanceAccounts={googleEnhanced.setSelectedAccounts}
                    googleEnhanceData={googleEnhanced.accountsData}
                    isModal
                    destinationType={destinationCode}
                />
            )}
        </div>
    );
};

export default GoogleEnhancedForm;
